export let navigation = ($) => {
  let onDropdown = false;

  $(".js-nav-item").mouseover(function () {
    var $this = $(this);
    let navId = $this.data("id");
    $(".js-desktop-nav-children").each(function () {
      var el = $(this);
      if (el.attr("data-parent-id") == navId) el.addClass("active");
      else el.removeClass("active");
    });
  });

  $(".js-nav-item").mouseenter(function () {
    let searchForm = document.querySelector(".js-nav-search-form");
    if (
      !(this.nextElementSibling === $(".js-show-nav-search")) &&
      $(this).hasClass("menu-item-has-children")
    ) {
      searchForm.classList.add("invisible");
      searchForm.classList.add("opacity-0");
    }
  });

  $(".js-desktop-nav-children").mouseover(function () {
    $(this).addClass("active");
  });

  $(".children-items").mouseleave(function () {
    $(".js-desktop-nav-children").each(function () {
      var el = $(this);
      el.removeClass("active");
    });
  });

  $(".js-nav-item").mouseleave(function () {
    if (onDropdown) {
      return;
    }
    $(".js-desktop-nav-children").each(function () {
      var el = $(this);
      el.removeClass("active");
    });
  });

  $(".js-nav-item").on("click", function () {
    if ($(this).data("hasChildren")) {
      let navId = $(this).data("id"),
        child = $('.js-nav-children[data-parent-id="' + navId + '"]'),
        openItem = $(".js-nav-children.active").data("parentId");
      if (openItem != navId && typeof openItem != "undefined") {
        $(".js-nav-children").not(child).removeClass("active");

        setTimeout(function () {
          child.toggleClass("active");
        }, 500);
      } else {
        child.toggleClass("active");
      }
    }
  });

  $(".js-nav-item.menu-item-has-children > a").on("click", function (e) {
    if (window.innerWidth < 1024) {
      e.preventDefault();
    }
  });

  $(".mobile-drawer").on("click", function () {
    $(this).toggleClass("fa-bars").toggleClass("fa-times");
    $(".js-nav-drawer").toggleClass("active");
  });
};
